import generateShortUUID from 'short-uuid'

/**
 *  ID must start with a letter because oxomi.embedDocument and other methods uses querySelector under the hood,
 * /and querySelector can't select id's that start with a digit
 *  https://stackoverflow.com/questions/20306204/using-queryselector-with-ids-that-are-numbers
 */
export const generateOxomiId = () => {
  return `ID_${generateShortUUID.generate()}`
}
